import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AssetResource} from '../../../../../class/lifeproject/asset-resource';
import {AbstractAsset} from '../../../../../class/abstract-asset';

@Component({
  selector: 'app-asset-row',
  templateUrl: './asset-row.component.html',
  styleUrls: ['./asset-row.component.css']
})
export class AssetRowComponent implements OnInit {

  @Input()
  assetResource: AssetResource;

  @Output()
  onRowUpdate = new EventEmitter();

  @Output()
  onRowDelete = new EventEmitter<AssetResource>();

  @Input()
  showEditor = false;

  constructor() {
  }

  ngOnInit() {
  }

  resetValue() {
    this.onRowDelete.emit(this.assetResource);
  }

  get asset(): AbstractAsset {
    return this.assetResource.asset;
  }

}
